export default function getCustomSvg(svg, colorMap) {
    const parser = new DOMParser();
    const svgDoc = parser.parseFromString(svg, "image/svg+xml");

    // Update fills
    svgDoc.querySelectorAll("[fill]").forEach((element) => {
        const currentFill = element.getAttribute("fill");
        if (colorMap[currentFill]) {
            element.setAttribute("fill", colorMap[currentFill]);
        }
    });

    // Update stop colors in gradients
    svgDoc.querySelectorAll("stop[stop-color]").forEach((stop) => {
        const currentStopColor = stop.getAttribute("stop-color");
        if (colorMap[currentStopColor]) {
            stop.setAttribute("stop-color", colorMap[currentStopColor]);
        }
    });

    return new XMLSerializer().serializeToString(svgDoc);
};

